import { createContext, useContext } from 'react';

/**
 * Context for tracking when node positions should animate.
 * Used for smooth transitions during layout operations (AI edits, manual re-layout, etc.)
 */
export interface NodeAnimationContextType {
    /**
     * Whether node position changes should be animated.
     */
    isAnimating: boolean;
}

const defaultValue: NodeAnimationContextType = {
    isAnimating: false,
};

export const NodeAnimationContext = createContext<NodeAnimationContextType>(defaultValue);

/**
 * Hook to access the node animation state.
 * Returns whether position animations should be enabled.
 */
export function useNodeAnimation(): NodeAnimationContextType {
    return useContext(NodeAnimationContext);
}
